<template>
  <b-row>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <u-loader v-if="isLoading && !versionNotFound" />
    <b-tabs
      v-else-if="contractVersions"
      :key="contractVersions.length"
      v-model="activeTab"
      class="contractVersionsTabControl w-100"
    >
      <b-tab
        v-for="(contractVersionInfo, index) in contractVersions"
        :key="index"
        :title="'Version ' + contractVersionInfo.number"
        @click="tabClicked(contractVersionInfo)"
      >
        <div v-if="contractVersions[activeTab]">
          <b-card
            v-if="
              contractVersions[activeTab].number == contractVersionInfo.number
            "
            class="shadow-sm"
          >
            <version-details
              v-if="versionNumber && !versionNotFound"
              :key="versionNumber"
              :contract-id="contractId"
              :version-id="versionNumber"
              :version-id-id="contractVersionInfo.id"
              @VersionDeleted="versionDeleted"
            />
            <div v-else-if="!versionNumber">
              Wählen Sie eine Version aus.
            </div>
          </b-card>
        </div>
      </b-tab>
      <b-tab
        v-if="
          $IsUserInRole('VertragsmanagementVerwaltung') ||
            ($IsUserInRole('VertragsmanagementUniaVertragsverantworlich') &&
            canUniaVerantwortlicheEdit === true)
        "
        style="padding: 0px"
        @click="modalTabClicked()"
      >
        <template slot="title">
          <div
            v-b-modal.createNewVersion
            v-b-tooltip.hover
            class="addVersionButton"
            placement="bottom"
            title="Neue Version erstellen"
          >
            <i class="fas fa-plus" />
          </div>
        </template>
      </b-tab>
    </b-tabs>
    <b-alert
      v-show="versionNotFound"
      class="w-100 mt-4"
      show
      variant="danger"
    >
      Die Version {{ versionNumber }} wurde nicht gefunden oder wurde kürzlich
      gelöscht. Wählen Sie bitte eine andere Version aus.
    </b-alert>

    <b-modal
      id="createNewVersion"
      ref="createNewVersion"
      hide-footer
      no-fade
      title="Neue Version erstellen"
    >
      <u-loader v-if="isLoading" />
      <div v-else>
        <div class="d-block mb-4">
          <label>
            <input
              v-model="newEmptyVersion"
              name="check"
              type="checkbox"
            >
            <span class="label-text">Eine leere Version erstellen</span>
          </label>
          <div v-if="!newEmptyVersion">
            <b>Existierende Version kopieren</b>
            <VersionEditionSelection
              ref="VersionEditionSelection"
              v-model="selection"
              :current-contract-number="contractId"
              :current-version-number="versionNumber"
            />
            <b-alert
              v-if="NewVersionErrorMessage"
              class="w-100 mt-4"
              show
              variant="danger"
            >
              {{ NewVersionErrorMessage }}
            </b-alert>
          </div>
        </div>
        <b-button
          variant="success"
          @click="createNewVersion"
        >
          Ok
        </b-button>
        <b-button
          class="ml-2"
          variant
          @click="cancelNewVersion"
        >
          Abbrechen
        </b-button>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import VersionDetails from "@/components/contract/version/VersionDetails.vue";
import VersionEditionSelection from "@/components/contract/version/VersionEditionSelection.vue";
import {
  GetAllContractVersions,
  CreateNewContractVersion,
  CreateNewContractVersionFromCopy,
  GetVersionInformation,
} from "@/services/contract.service.js";

export default {
  components: {
    VersionDetails,
    VersionEditionSelection,
  },
  props: {
    contractId: {
      type: String,
      default: "",
    },
    versionNumber: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      contractVersions: null,
      activeTab: null,
      previousTab: null,
      isLoading: false,
      errorObject: null,
      versionNotFound: false,
      newEmptyVersion: false,
      selection: {
        VersionId: -1,
        EditionId: -1,
        CopyMindestlohn: 1,
      },
      NewVersionErrorMessage: "",
      canUniaVertragsverantwortlichEdit: true,
    };
  },

  computed: {
    canUniaVerantwortlicheEdit() {
      if (this.$store.state.adminCurrentContract.VersionData?.ave) {
        if (
          this.$store.state.adminCurrentContract.VersionData.ave.aveState != 0
        ) {
          return false;
        } else if (
          this.$store.state.adminCurrentContract.VersionData.ave.aveState ==
            0 &&
          this.$store.state.adminCurrentContract.VersionData.anhang1 === true
        ) {
          return false;
        } else if (
          this.$store.state.adminCurrentContract.VersionData.ave.aveState ==
            0 &&
          this.$store.state.adminCurrentContract.VersionData.anhang1 === false
        ) {
          return true;
        }
      }

      if (!this.$store.state.adminCurrentContract.VersionData) {
        return true;
      }
      if (!this.$store.state.adminCurrentContract.VersionData.ave) {
        if (
          this.$store.state.adminCurrentContract.VersionData.anhang1 === true
        ) {
          return false;
        } else if (
          this.$store.state.adminCurrentContract.VersionData.anhang1 === false
        ) {
          return true;
        }
      }

      return false;
    },
  },

  created: function () {
    // this is for if the users clicks the "back"-button in browser.
    // Because the tabs are only some part of the history (it appears, but does not navigate too if clicked, so we have to handle it ourselves),
    // a reload is needed to display the correct version
    window.onpopstate = function () {
      location.reload();
    };

    this.LoadContractVersionTabControl();
  },

  methods: {
    versionDeleted(deletedVersionId) {
      var currentVersion = this.contractVersions.filter((item) => {
        return item.number == deletedVersionId;
      });

      if (
        currentVersion &&
        this.contractVersions.indexOf(currentVersion[0]) != 0
      ) {
        this.activeTab = null;
        this.contractVersions.splice(
          this.contractVersions.indexOf(currentVersion[0]),
          1,
        );
      }

      this.LoadContractVersionTabControl();
    },
    createNewVersion() {
      if (!this.newEmptyVersion) {
        this.NewVersionErrorMessage = "";

        if (
          (!this.selection.VersionId || this.selection.VersionId != -1) &&
          (!this.selection.EditionId || this.selection.EditionId != -1)
        ) {
          this.isLoading = true;
          this.errorObject = null;
          CreateNewContractVersionFromCopy(
            this.contractId,
            this.selection.VersionId,
            this.selection.EditionId,
            this.selection.CopyMindestlohn,
            this.selection.MiloSalaryImport,
            (versionNumber) => {
              this.hideModal("createNewVersion");
              this.isLoading = false;
              this.LoadContractVersionTabControl();
              this.activeTab = versionNumber;
              this.tabClicked({ number: versionNumber });
            },
            (error) => {
              this.isLoading = false;
              this.errorObject = error;
            },
          );
        } else {
          this.NewVersionErrorMessage =
            "Es muss eine Version und eine Edition ausgewählt werden";
        }
      } else {
        this.isLoading = true;
        this.errorObject = null;

        this.hideModal();
        CreateNewContractVersion(
          this.contractId,
          (createdVersion) => {
            this.hideModal("createNewVersion");
            this.isLoading = false;
            this.LoadContractVersionTabControl();
            this.activeTab = createdVersion.number;
            this.tabClicked(createdVersion);
          },
          (error) => {
            this.isLoading = false;
            this.errorObject = error;
          },
        );
      }
    },
    hideModal() {
      this.$refs["createNewVersion"].hide();
      this.newEmptyVersion = false;
      this.selection = {
        VersionId: -1,
        EditionId: -1,
        CopyMindestlohn: 1,
      };
    },
    cancelNewVersion() {
      this.hideModal();

      var currentVersion = this.contractVersions.filter((version) => {
        return version.number == this.versionNumber;
      })[0];

      setTimeout(() => {
        this.activeTab = this.contractVersions.indexOf(currentVersion);
      }, 0);
    },
    modalTabClicked() {
      var latestVersion =
        this.contractVersions[this.contractVersions.length - 1].number;
      if (this.selection.VersionNumber != latestVersion) {
        this.selection.VersionNumber = latestVersion;
        this.$refs.VersionEditionSelection.selectFirstEdition();
      }
    },
    tabClicked(versionInfo) {
      this.versionNotFound = false;
      this.$router.push({
        path: `/contract-overview/${this.contractId}/${versionInfo.number}`,
        query: { source: this.$route.path },
      });

      this.$emit("displayVersionChanged", versionInfo.number);
    },
    LoadContractVersionTabControl() {
      this.isLoading = true;
      this.versionNotFound = false;

      GetAllContractVersions(
        this.contractId,
        (allVersions) => {
          this.isLoading = false;
          this.contractVersions = allVersions.data;

          if (this.contractVersions.length > 0) {
            GetVersionInformation(
              this.contractId,
              this.contractVersions[this.contractVersions.length - 1].number,
              (result) => {
                if (
                  result.translatedToLanguages &&
                  result.translatedToLanguages.length
                ) {
                  this.$store.commit(
                    "setAdminCurrentContractTranslatedLanguages",
                    result.translatedToLanguages,
                  );
                }
                var germanContent = result.versionContents.filter((content) => {
                  return content.language == "de-CH";
                });

                if (germanContent[0]) {
                  this.$emit("latestVersionLoaded", germanContent[0].nameShort);
                  this.$store.commit(
                    "setAdminCurrentContractShortName",
                    germanContent[0].nameShort,
                  );
                } else if (
                  result.versionContents &&
                  result.versionContents[0]
                ) {
                  this.$emit(
                    "latestVersionLoaded",
                    result.versionContents[0].nameShort,
                  );
                  this.$store.commit(
                    "setAdminCurrentContractShortName",
                    result.versionContents[0].nameShort,
                  );
                }

                this.$store.commit("setAdminCurrentVersionData", result);

                if (result?.ave?.aveState != 0 || result?.anhang1 === true) {
                  this.canUniaVertragsverantwortlichEdit = false;
                }
              },
              (error) => {
                console.error(error);
              },
            );
          }

          if (this.versionNumber) {
            var currentVersion = this.contractVersions.filter((item) => {
              return item.number == this.versionNumber;
            });

            if (currentVersion && currentVersion.length == 1) {
              this.activeTab = this.contractVersions.indexOf(currentVersion[0]);
              this.versionNotFound = false;
            } else {
              this.versionNotFound = true;
              this.activeTab = null;
              this.isLoading = false;
            }
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
  },
};
</script>

<style>
.contractVersionsTabControl .shadow-sm {
  border-top: none;
  border-radius: 0px;
}
</style>

<style scoped>
.addVersionButton {
  position: relative;
  text-align: center;
}
</style>
